import { iDontKnowAnswer } from '@/components/decision-tree/hooks';
import { displayDateFormat } from '@/constants/dates';
import { Box, Divider, Flex, Grid, Text } from '@cmpsr/components';
import { format } from 'date-fns';
import { FC, Fragment, useEffect } from 'react';
import { SummaryProps } from './types';

export const Summary: FC<SummaryProps> = ({ saveAnswer, summary }) => {
  const { date, header, body } = summary;

  const bodyKeys = Object.keys(body);

  useEffect(() => saveAnswer(iDontKnowAnswer), []);

  return (
    <Box>
      <Text variant="text-header-L">Summary of Testing result</Text>
      <Text variant="text-body-regular" color="text-secondary" mt="spacer-2" textAlign="center">
        Date of screening: {format(date, displayDateFormat)}
      </Text>
      <Grid
        templateColumns="50% 50%"
        textAlign="left"
        borderRadius="radii-4"
        border="1px solid"
        borderColor="ui-element-divider"
        p="spacer-6"
        mt={{ base: 'spacer-5', lg: 'spacer-6' }}
        rowGap="spacer-3"
      >
        {Object.keys(header).map((headerKey) => (
          <Fragment key={headerKey}>
            <Flex>
              <Text variant="text-body-regular" color="text-secondary" textTransform="capitalize">
                {headerKey}
              </Text>
            </Flex>
            <Flex>
              <Text variant="text-body-medium" textTransform="capitalize">
                {header[headerKey]}
              </Text>
            </Flex>
          </Fragment>
        ))}
        {bodyKeys.length > 0 && (
          <Flex gridColumnStart="1" gridColumnEnd="3">
            <Divider />
          </Flex>
        )}
        {bodyKeys.map((bodyKey) => (
          <Fragment key={bodyKey}>
            <Flex>
              <Text variant="text-body-meta-regular" color="text-secondary" textTransform="capitalize">
                {bodyKey}
              </Text>
            </Flex>
            <Flex>
              <Text variant="text-body-meta-regular" textTransform="capitalize">
                {body[bodyKey]}
              </Text>
            </Flex>
          </Fragment>
        ))}
      </Grid>
    </Box>
  );
};
